import { LinkButton } from '@/atoms/Button'
import { QuestionMarkFilled } from '@/atoms/Icons/QuestionMarkFilled'
import { ParagraphMD } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface HelpCastingButton {
  onClick?: () => void
}

export const HelpCastingButton: React.FC<HelpCastingButton> = ({ onClick }) => {
  const { t } = useTranslate('common')

  return (
    <LinkButton
      className="max-h-[41px] min-w-[190px] rounded"
      variant="core-gray-300"
      href={paths.blog.castToTv}
      onClick={onClick}
      prefetch={false}
      target="_blank"
    >
      <div className="mx-auto flex flex-row justify-center gap-2 text-core-gray-950">
        <QuestionMarkFilled size={20} color1="core-gray-950" color2="core-gray-300" className="m-auto" />
        <ParagraphMD className="md:hidden 2xl:block" weight="semibold">
          <Translate t={t} i18nKey="helpCastingToTv">
            Help Casting to TV
          </Translate>
        </ParagraphMD>
        <ParagraphMD className="hidden md:block 2xl:hidden" weight="semibold">
          <Translate t={t} i18nKey="helpCasting">
            Help Casting
          </Translate>
        </ParagraphMD>
      </div>
    </LinkButton>
  )
}
